import CaseListContainer from './CaseListContainer'

export default CaseListContainer
